import { render, staticRenderFns } from "./EditUi.vue?vue&type=template&id=40fb43c4&scoped=true"
import script from "./EditUi.vue?vue&type=script&lang=js"
export * from "./EditUi.vue?vue&type=script&lang=js"
import style0 from "./EditUi.vue?vue&type=style&index=0&id=40fb43c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb43c4",
  null
  
)

export default component.exports